import SSRIcon from './SSRIcon';

export default SSRIcon;
